import {httpAuth,http} from './config';

export default {
    showCompanyByToken:() => {
        return httpAuth.get('api/external/company/show');
    },
    index:() => {
        return httpAuth.get('v1/empresas');
    },
    indexSimple:() => {
        return httpAuth.get('v1/empresas?simple=true');
    },
    show:(id) => {
        return httpAuth.get('v1/empresas/' + id)
    },
    create:(company) => {
        return http.post('api/v1/empresas', company);
    },
    update:(company) => {
        return httpAuth.put('api/external/company/' + company.id, company);
    },
    delete: (id) => {
        return httpAuth.delete('v1/empresas/'+ id);
    }
}